import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Languages from '../general/Languages';

class ComponentHeader extends React.Component<any, any> {
  render() {
    return (
      <div className="title">
        <Link to="/" className="material-icons">arrow_back</Link>
        <FormattedMessage id="report" defaultMessage="Report" />
        <div className="pull-right">
          <Languages language={this.props.language} onSelect={this.props.changeLang} />
        </div>
      </div>
    );
  }
}

export default ComponentHeader;
